import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AnalyticsQueueService {

  private queue: Array<() => void> = [];
  private ready = true;

  setReady() {
    this.ready = true;
    this.flush();
  }

  push(fn: () => void) {
    if (this.ready) fn();
    else this.queue.push(fn);
  }

  private flush() {
    this.queue.forEach(fn => fn());
    this.queue = [];
  }
}
